// Quadros (kanbans/cronogramas) do usuário — ver docs/API.md do planbackgo, seção "Quadros".
import type { ColorName } from '@/utils/colors';

/** `daily`: dia a dia (um deles é o principal); `project`: projeto com período (cronograma). */
export type BoardType = 'daily' | 'project';

export interface BoardColumn {
  id: number;
  board_id: number;
  name: string;
  sort_order: number;
  color: ColorName | string;
  is_done_column: boolean;
  wip_limit?: number;
}

export interface Board {
  id: number;
  name: string;
  description?: string;
  board_type: BoardType;
  is_main: boolean;
  start_date?: string;
  end_date?: string;
  color: ColorName | string;
  is_archived: boolean;
  is_active: boolean;
  columns?: BoardColumn[];
  open_count: number;
  overdue_count: number;
  created_at: string;
  created_by: string;
  updated_at?: string;
  last_updated_by?: string;
}

export interface BoardFormData {
  name: string;
  description?: string | null;
  board_type: BoardType;
  is_main: boolean;
  start_date?: string | null;
  end_date?: string | null;
  color?: string;
  is_archived: boolean;
}

export interface BoardColumnFormData {
  name: string;
  color?: string;
  is_done_column: boolean;
  wip_limit?: number | null;
}

export const BOARD_TYPE_LABELS: Record<BoardType, string> = {
  daily: 'Dia a dia',
  project: 'Projeto',
};
